module.exports = new __parcel__URL__("battlepass_season.8b04a71f.png").toString();